module.exports = __webpack_public_path__ + "static/media/two-factor.5e593bcf.svg";